import styled from 'styled-components'

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  button {
    width: 232px;
  }
`
